// Auto generated by ControleTool.ModelClassGenerator
import { inject } from 'aurelia-framework';
import { ValidationRules } from 'aurelia-validation';
import { Helpers } from '../services/helpers';
import { SchoolClassViewModel } from './schoolclassview-model';


export class StudentViewModel {
    schoolClassId: number = 0;
	schoolClass: SchoolClassViewModel = null;
	isActive: boolean = true;
	lastLoginDate: Date = null;
	firstLoginDate: Date = null;
	email: string = null;
	fullname: string = null;
	
	constructor(data: any = null) {
        
		if (data) {
			Helpers.mapProperties(data, this);
        }
        ValidationRules
			.ensure('schoolClassId').displayName('Schoolklas').required()
			.ensure('email').displayName('E-mail').required()
			.on(this);
	}
}